import { CATEGORIES_SORTED, Category } from '../../types/Categories';
import React from 'react';
import {
  Avatar,
  Dialog,
  DialogTitle,
  Divider,
  List,
  ListItemAvatar,
  ListItemText,
} from '@mui/material';

import ListItemButton from '@mui/material/ListItemButton';

export interface SelectCategoryModalProps {
  open: boolean;
  category?: string;
  onCategorySelected: (category: Category | undefined) => void;
  onCancel: () => void;
}

export const SelectCategoryModal = (props: SelectCategoryModalProps) => {
  const { open, onCategorySelected, onCancel, category } = props;
  return (
    <Dialog open={open} onClose={onCancel} maxWidth={'sm'} fullWidth>
      <DialogTitle>Catégories</DialogTitle>
      <Divider />
      <List sx={{ maxHeight: 350, overflow: 'auto' }}>
        <ListItemButton
          selected={category === undefined}
          onClick={() => onCategorySelected(undefined)}
        >
          <ListItemText primary={'Aucune'} />
        </ListItemButton>
        {CATEGORIES_SORTED.map((c) => (
          <ListItemButton
            key={c.key}
            selected={category === c.key}
            onClick={() => onCategorySelected(c)}
          >
            <ListItemAvatar>
              <Avatar style={{ backgroundColor: c.color }}>
                <c.icon htmlColor={'white'} />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={c.name} />
          </ListItemButton>
        ))}
      </List>
    </Dialog>
  );
};
